import { cn } from '@bem-react/classname';

export const cnApp = cn('App');

export const appHeadTitleCn = cnApp('HeadTitle');
export const appHeadBackButtonCn = cnApp('HeadBackButton');
